<button type="button" mat-icon-button [disabled]="isLoadingOrReloading()" (click)="reload()" matTooltip="Neu laden">
  <mat-icon [ngClass]="{ spin: isLoadingOrReloading() }">refresh</mat-icon>
</button>
